export default __webpack_public_path__ + "static/media/MentionsLegales.a1ba494d.md";